/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::account::transfer`. */
export const transfer = "0x1::account::transfer" as const;

/** Script function type for `0x1::account::create_account`. */
export const create_account = "0x1::account::create_account" as const;

/** Script function type for `0x1::account::rotate_authentication_key`. */
export const rotate_authentication_key =
  "0x1::account::rotate_authentication_key" as const;

/** Script function type for `0x1::account::rotate_authentication_key_ed25519`. */
export const rotate_authentication_key_ed25519 =
  "0x1::account::rotate_authentication_key_ed25519" as const;
